import type { I18n } from "vue-i18n";

export default defineNuxtPlugin({
  name: "ckweb:zod-i18n",
  dependsOn: ["ckweb:settings", "ckweb:common"],
  setup(nuxtApp) {
    $ck.z.setErrorMap(
      $ck.utils.makeZodI18nMap(<I18n>{ global: nuxtApp.$i18n }, "zodErrors"),
    );
  },
});
